import type { Brand } from '../../../types/brand';
import type { ScoreOverview } from '../../../types/scores';
import type { BrandScoreDailyRow } from '../types';

export function rowsToScoreOverview(
  rows: BrandScoreDailyRow[],
  brands: Brand[]
): ScoreOverview[] {
  return rows.map((row) => {
    const brand = brands.find((b) => b.id === row.brand_id);
    
    return {
      brand_id: row.brand_id,
      visibility: Math.round(Number(row.avg_visibility_score)),
      sentiment: Math.round(Number(row.avg_sentiment_score)),
      ranking: Math.round(Number(row.avg_position) * 10) / 10,
      brand_name: brand?.name ?? '',
      logo_url: brand?.logoUrl ?? '',
    };
  });
}

interface AggregateByBrandResult {
  sumVisibility: number;
  sumSentiment: number;
  sumPosition: number;
  count: number;
}

export function aggregateByBrand(rows: BrandScoreDailyRow[]): BrandScoreDailyRow[] {
  const byBrand = new Map<number, AggregateByBrandResult>();

  for (const row of rows) {
    const cur = byBrand.get(row.brand_id) ?? {
      sumVisibility: 0,
      sumSentiment: 0,
      sumPosition: 0,
      count: 0,
    };
    cur.sumVisibility += Number(row.avg_visibility_score);
    cur.sumSentiment += Number(row.avg_sentiment_score);
    cur.sumPosition += Number(row.avg_position);
    cur.count += 1;
    byBrand.set(row.brand_id, cur);
  }
  
  return Array
    .from(byBrand.entries())
    .map(([brand_id, agg]) => ({
      date: '',
      user_id: '',
      brand_id,
      avg_visibility_score: agg.sumVisibility / agg.count,
      avg_sentiment_score: agg.sumSentiment / agg.count,
      avg_position: agg.sumPosition / agg.count,
    }));
}
